import moment from 'moment';

export function calcBusinessDays(
  action: 'add' | 'subtract',
  originalDate: Date,
  numDays: number
) {
  const Sunday = 0;
  const Saturday = 6;
  let daysRemaining = numDays;

  const newDate = moment(originalDate);

  while (daysRemaining > 0) {
    newDate[action](1, 'days');
    if (newDate.day() !== Sunday && newDate.day() !== Saturday) {
      daysRemaining--;
    }
  }

  return newDate;
}
